import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import styles from "../push-modal.module.scss";

import { Button, Input, LoadingIndicator } from "../../../../components/simple";
// import SVG from "../../../../components/SVG";
import { PLATFORMS } from "../platforms";

import { ttdClearErrorState } from "../../../../store/actions/platforms/index";

const TheTradeDesk = ({
  audienceType,
  editAudienceHandler,
  selectedPlatform,
  handlePushToPlatform,
  ttdPartnerId,
  handleTtdPartnerIdChange,
  fieldError,
  allowEdit
}) => {
  const { isLoading } = useSelector(state => state.platforms);
  const dispatch = useDispatch();

  const handleInputChange = (name, value) => {
    handleTtdPartnerIdChange(value);
    dispatch(ttdClearErrorState());
  };

  const handleSubmit = e => {
    e.preventDefault();

    handlePushToPlatform(PLATFORMS.ttd);
  };

  return (
    <>
      <div
        className={`${styles["ttd-signin"]} ${
          selectedPlatform === PLATFORMS.ttd ? styles["slide-from-right"] : ""
        }`}
      >
        {/* <div className={styles["platform-logo"]}>
          <SVG.TheTradeDesk /> The Trade Desk
        </div> */}
        <div className={styles["connect-account"]}>Enter a partner id:</div>

        <form onSubmit={handleSubmit}>
          <Input
            placeholder="Partner id"
            style={{ marginTop: 20 }}
            value={ttdPartnerId}
            label=""
            handleChange={handleInputChange}
            invalid={fieldError?.length}
            fieldError={fieldError}
          />
          {isLoading ? (
            <div
              style={{ marginTop: "32px" }}
              className="mt-4 d-flex justify-content-center"
            >
              <LoadingIndicator />
            </div>
          ) : (
            <div className="mt-5">
              <Button
                disabled={!ttdPartnerId || isLoading || fieldError}
                type="submit"
                className={styles["push-audience-btn"]}
              >
                <span>Push</span>
              </Button>
              {audienceType === "audience" && allowEdit && (
                <Button
                  type="button"
                  className={`btn btn-secondary ${styles["edit-audience-btn"]}`}
                  onClick={editAudienceHandler}
                >
                  <span>Edit audience</span>
                </Button>
              )}
            </div>
          )}
        </form>

        <div className={styles["platform-description"]}></div>
      </div>
    </>
  );
};

TheTradeDesk.propTypes = {
  audienceType: PropTypes.string.isRequired,
  ttdPartnerId: PropTypes.string,
  handleTtdPartnerIdChange: PropTypes.func,
  handlePushToPlatform: PropTypes.func,
  fieldError: PropTypes.string,
  selectedPlatform: PropTypes.string,
  editAudienceHandler: PropTypes.func.isRequired,
  allowEdit: PropTypes.bool.isRequired
};

TheTradeDesk.defaultProps = {
  selectedPlatform: "",
  handlePushToPlatform: () => {},
  ttdPartnerId: "",
  handleTtdPartnerIdChange: () => {},
  fieldError: ""
};

export default TheTradeDesk;
